import type { Task } from '../types';

/**
 * 最近任务展示数量
 */
export const RECENT_TASKS_COUNT = 5;

export const DEFAULT_PAGE_SIZE = 10;

export const DEFAULT_VALUE: Task = {
    tasks: [],
    pagination: {
        page: 1,
        pageSize: DEFAULT_PAGE_SIZE,
        total: 0,
    },
    isLoading: false,
};
